// The words of selection and bulk work, in one place.

export const HEADER_LABEL = 'Select all eligible rows on this page'
// a grouped section has no pages: its header checkbox names the group it selects
export const groupHeaderLabel = title => `Select all eligible rows in ${title}`
export const DEFAULT_INELIGIBLE = 'This row cannot be selected'
export const BATCH_DISABLED = 'Clear selection to use row actions'
export const FAILURE_TEXT = 'The action could not be completed. Try again.'
export const CANCEL = 'Cancel'

const rows = n => `${n} ${n === 1 ? 'row' : 'rows'}`

export const rowLabel = identity => `Select ${identity}`
export const selectedLabel = n => `${n} selected`
export const escalateLabel = n => `Select all ${n} matching`
export const allSelectedLabel = n => `All ${n} matching selected`
export const workingLabel = n => `Working on ${n} rows...`
export const changedText = (from, to) =>
  `The matching set changed from ${from} to ${to}. Review and try again.`
export const successText = n => `${n} rows completed.`
export const partialText = (s, n, f) =>
  `${s} of ${n} rows completed. ${f} could not be completed.`
export const confirmQuestion = (label, n) => `${label} ${rows(n)}?`
export const doneText = (label, n) => `${label}: ${rows(n)}`
